/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
    export class ContaAtivacao {
        public static inicializar() {
            var contaAtivacao = new App.ContaAtivacao();
            contaAtivacao.inicializarEventos();
        }
    }
}

namespace App {
    export class ContaAtivacao {
        private ajax: IAjax;

        private elBtnReenviarConfirmacao: JQuery = $("#btReenviarConfirmacaoEmail");

        public inicializarEventos() {
            this.elBtnReenviarConfirmacao.on('click', (e) => { this.aoReenviarConfirmacao(e); });
        }

        private aoReenviarConfirmacao(e: JQueryEventObject) {
            this.ajax = new App.Ajax();
            var dados: any = {};
            this.ajax.postAcao($(e.target).data("url"), dados);
        }

    }
}
